/**
 * English version of the terms of use. Translation of TermsRu.tsx (the Russian
 * original); keep both in step — same sections, same rules.
 */
import { LegalDoc, List, Section } from '../LegalDoc';

const UPDATED = 'August 5, 2026';

export function TermsEn() {
  return (
    <LegalDoc
      title="Terms of Use"
      updated={UPDATED}
      sibling={{ href: '/privacy', label: 'Privacy Policy' }}
    >
      <p className="mt-4 text-sm text-ink-muted">
        This is a translation of the Russian original. If they differ, the Russian version prevails.
      </p>
      <Section title="In short">
        <p>
          Bunker is the messenger and voice chat of the cispracs platform. By using it, you agree to
          these terms. If you do not agree, do not use it: you can delete your account at any time.
        </p>
      </Section>

      <Section title="Account">
        <List
          items={[
            ['Sign-in via cispracs', 'Bunker has no separate password; the platform manages your account.'],
            ['Age', 'Bunker is not intended for children under 13.'],
            ['One person', 'the account is personal. The owner is responsible for everything done under it, so do not give others access.'],
            ['Authenticity', 'do not impersonate another person, team or platform staff member.'],
          ]}
        />
      </Section>

      <Section title="What you may not post">
        <p className="mb-2">
          Everything you send — text, photos, files, voice, polls, server and channel names — is your
          responsibility. Prohibited:
        </p>
        <List
          items={[
            ['Illegal content', 'anything that breaks the law, including child sexual exploitation material — for this the account is deleted without warning and the material is passed on to the appropriate parties.'],
            ['Harassment and threats', 'harassment, threats, inciting hatred on any grounds, doxxing — publishing other people’s personal data.'],
            ['Harm', 'malware, phishing, account-stealing links, scams for money.'],
            ['Spam', 'mass messaging, fake engagement, automated accounts and invites.'],
            ['Other people’s content', 'content whose rights belong to others, unless you have permission.'],
            ['Circumventing restrictions', 'attempts to bypass permissions, roles, blocks, timeouts and moderation — including by technical means.'],
          ]}
        />
      </Section>

      <Section title="How this is enforced">
        <p>
          Any message and any user can be reported right in the app: message menu → “Report”, profile
          card → “Block”. Reports are handled by the server’s moderators, and critical ones go to
          platform moderation. We may remove content, restrict or delete an account if the rules are
          broken. A decision can be appealed by replying to the email from support.
        </p>
      </Section>

      <Section title="Your servers">
        <p>
          Whoever created a server is responsible for it: its members, roles, names and what happens
          there. Owner rights do not override these terms.
        </p>
      </Section>

      <Section title="Rights to content">
        <p>
          Your content stays yours. By sending it, you allow us to store, transmit and show it to
          those it is addressed to — a messenger cannot work without this. We do not use your content
          for advertising and do not pass it to third parties for profit.
        </p>
      </Section>

      <Section title="Service as is">
        <p>
          Bunker is provided free of charge and “as is”: we do not promise uninterrupted operation, we
          may change and turn off features and carry out maintenance. Voice is not recorded, and the
          message history is not a backup — keep anything important yourself.
        </p>
      </Section>

      <Section title="Termination">
        <List
          items={[
            ['On your side', 'delete your account — in the app: profile → “Delete account”.'],
            ['On our side', 'if these terms or legal requirements are violated, access may be restricted or terminated.'],
          ]}
        />
      </Section>

      <Section title="Changes and contact">
        <p>
          If the terms change, a new date will appear here, and we will show significant changes in
          the app. Questions —{' '}
          <a className="text-accent underline" href="mailto:support@cispracs.ru">
            support@cispracs.ru
          </a>
          .
        </p>
      </Section>
    </LegalDoc>
  );
}
